document.addEventListener('DOMContentLoaded', function() {
  const section = document.querySelector('section[id^="ProductInformation-"]');
  console.log('Section encontrado:', section); // Verifica si existe
  if (section && section.id != "ProductInformation-08042026") {
    console.log('Script No aplicable en el entorno actual');
    return;
  }
});

//Esta variable va a tener todo el contenido HTML de la informacion del producto
    let contenidoHTML = [];

//Toma la clase raiz de las descripciones
    const infoProducto = document.querySelector('.product-description'); 

  //Funcion para crear dinamicamente las descripciones
  function iniciarClasesHTML(rows, infoProducto){

    //Si encuentra la clase empieza la ejecución
    if (infoProducto){

      //Guarda todo el contenido base de la pagina
      let html = infoProducto.innerHTML;

      //Acá esta la lógica de todo el script
      let htmlSobrante = html.replace(
        //Encuentra un patrón, excluyendo ":", de forma global y sin ser case-sensitive
        /<strong>([^:]+):<\/strong>\s*([^<]+)<br\s*\/?>?/gi, 

        //Ejecuta una función anonima
        function (match, label, value) {

          //Las variables match, label, value son temporales. Por eso las mandamos todas al array que formamos anteriormente
         rows.push([label.trim(),value.trim()]);
          //la función anonima exige un return de algun tipo, esto no hace nada mas que cumplir eso
          return '';
        }
      );
      return htmlSobrante;
  }
}


  function crearDescripciones(htmlSobrante){

    let descripcion = document.createElement('p');

      //Esto limpia el formato sobrante del HTML que pertenece a la descripción
      descripcion.innerHTML = htmlSobrante.replace(/<br\s*\/?>/gi, '').trim();

      //Contendra la estructura final de la descripcion en caso de que tenga
      let descFinal;

      //Caso contrario llena la descripcion con el contenido encontrado en lo que sobra del HTML
      if(descripcion.textContent.trim() != "") {
        descFinal = `
        <button id = "mostrar-mas-descr">
        Descripción
        <span class="arrow-down" id = "arrow-descr">&#9660;</span>
        </button> 
        <div class = "product-long-description" id="descr-info">
          <p class = "descr-sentence">${descripcion.textContent}</p>
        </div>`; 
        return descFinal;
      }
  }

  function categorizarSpecs(rows){

      //Categorias de las especificaciones
  const categorias = {
    "Batería":
    [
      "batería",
      "carga",
      "energia"
    ],
    "Pantalla": 
    [
      "pantalla", 
      "resolución",
      "tamaño",
      "relación de aspecto",
      "frecuencia"
    ],
    "Sonido":
    [
      "sonido",
      "audio"
    ],
    "Conectividad":
    [
      "usb",
      "hdmi",
      "vga",
      "conectividad",
      "ethernet",
      "red",
      "SIM",
      "puertos"
    ],
    "Cámara":[
      "cámara",
      "flash"
    ],
    "Especificaciones": [
      "memoria",
      "RAM",
      "procesador",
      "sistema operativo",
      "núcleos",
      "disco",
      "tarjeta gráfica",
      "almacenamiento"
    ],
    "General":[
      "marca",
      "compañia",
      "color",
      "línea",
      "modelo",
      "peso",
      "seller",
      "paquete"
    ],
    "Otros":[]
  };

  let agrupados={};

    rows.forEach(([label, value]) => {

        let labelToLower=label.toLowerCase();
        let asignarCategoria = "Otros"; 

        for (const [categoria, palabrasClaves] of Object.entries(categorias)){
          if (palabrasClaves.some(palabraClave => labelToLower.includes(palabraClave))){
            asignarCategoria=categoria;
            break;
          }
        }

        if(!agrupados[asignarCategoria]){
          agrupados[asignarCategoria]=[];
        }
        agrupados[asignarCategoria].push([label,value]);
      });
  return agrupados;
}
      
  function crearTablaSpecs(categorias){
    //Construye la tabla
      let table = '<button id = "mostrar-mas-specs">Especificaciones Técnicas <span class="arrow-down" id = "arrow-specs">&#9660;</span></button>';

    for(const [grupos, items] of Object.entries(categorias)){
        if(!items.length) continue;

        table += `
          <div class = "description-table">
            <table class = "tabla-specs">
              <thead class = "encabezado">
                <tr>
                  <th colspan="2" class="titulo-${grupos}">
                    ${grupos}
                  </th>
                </tr>
              </thead>
              <tbody>
                ${items.map(([label, value]) => `
                  <tr class = "row-key-specs">
                    <th class = "key-spec">${label}</th>
                    <td class = "value-spec">${value}</td>
                  </tr>
                `).join('')}
              </tbody>
            </table>
          </div>
        `;
      }
      return table; 
  }
  //Boton que oculta o muestra la información del producto
function mostrarMas(){

  //Toma los elementos de la página (Descripcion, Especificaciones y las flechas)
  let descrInfo = document.getElementById("descr-info"); 
  let specsInfo = document.querySelectorAll(".description-table"); 
  const botonSpecs = document.getElementById("mostrar-mas-specs");
  const botonDescr = document.getElementById("mostrar-mas-descr");

  if(botonDescr === null){
    console.log("producto sin descripción");
  }
  else{
    //Inicia los EventListeners para dar funcionalidad a los botones Event Listener para el boton de las descripciones
    botonDescr.addEventListener("click", ()=> {
      //Si contiene la clase "Mostrar" entonces quita la clase y pone la flecha para abajo
      const descrActivo = descrInfo.classList.contains("mostrar")
      descrInfo.classList.toggle("mostrar", !descrActivo);
      botonDescr.classList.toggle("activo", !descrActivo);   
    });
  }

  //Event Listener para el boton de las especificaciones
  botonSpecs.addEventListener("click", ()=>{
    const specsActivo = specsInfo[0].classList.contains("mostrar");
    //Las especificaciones son divididas en divs mas pequeños, por lo que es necesario recorrer todos los div 

      //Si cualquiera de los div contiene la clase "Mostrar" entonces remueve la clase a cada div y cambia la flecha
        specsInfo.forEach( specsValue => {
          specsValue.classList.toggle("mostrar", !specsActivo);
        });
        botonSpecs.classList.toggle("activo", !specsActivo);
  });

  }



//Función principal que genera todo el contenido en base a las funciones anteriores
function estructurarContenido(){
  const obtenerHTMLBase = iniciarClasesHTML(contenidoHTML, infoProducto);
  let obtenerDescripciones = crearDescripciones(obtenerHTMLBase);
  let categorias = categorizarSpecs(contenidoHTML);
  let table = crearTablaSpecs(categorias);
  //Guarda la información y la aplica en la página
  if (obtenerDescripciones){
    infoProducto.innerHTML = obtenerDescripciones + table;
  }
  else{
    infoProducto.innerHTML = table;
  }

  //Funcion de mostrar mas o menos contenido
  //Tiene que ir al final para que los demas elementos puedan cargar correctamente
  mostrarMas();
}

//Función autoejecutable que valida si el DOM ya esta correctamente cargado
(() =>{

  //Función que valida que el contenido este correctamente cargado
function init(){
    estructurarContenido();
}

if(document.readyState != 'loading'){
    init();
}
else{
    document.addEventListener('DOMContentLoaded', init);
}

})();